import { SnackbarComponent } from './../dialogs/snackbar/snackbar.component';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../../../../src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
// import { DOCUMENT } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Leaderboard, ResponseData, TeamDetails, TeamGroup } from './teacher.interface';
import { QuestionDetails, QuestionStatus, ResponseType, ResultData, UnQnList } from '../../features/question/question.component';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  $baseUrl = environment.baseUrl;

  sdgSelected: Subject<any> = new Subject<any>();

  lstAllMovies = [
    //   {country:'Nederland',
    //   countryId:7,
    //   sdgIds:[],
    //   subjectIds:[1],
    //   heading:'Opening 2019',
    //   movie:'https://www.youtube.com/embed/b_fxthwy8DY',

    //   label:'',

    //   current_slide:0
    // },
    {
      country: 'Nederland',
      countryId: 7,
      sdgIds: [],
      subjectIds: [1],
      heading: 'Opening 2020',
      movie: 'https://www.youtube.com/embed/eVEuj8mXH7A',

      label: '',

      current_slide: 0
    },
    {
      country: 'Bhutan',
      countryId: 1,
      sdgIds: [],
      subjectIds: [2, 13],
      heading: 'My Global Impact Bhutan',
      movie: 'https://www.youtube.com/embed/USFprBNirPs',

      label: '',

      current_slide: 0
    },
    {
      country: 'Bhutan',
      countryId: 1,
      sdgIds: [],
      subjectIds: [3, 14],
      heading: 'Tradition of Bhutan',
      movie: 'https://www.youtube.com/embed/4PHQNqVlUi0',

      label: '',

      current_slide: 0
    },
    {
      country: 'China',
      countryId: 2,
      sdgIds: [],
      subjectIds: [3],
      heading: 'Interaction in China',
      movie: 'https://www.youtube.com/embed/cVm1ATGD4Ok',

      label: '',

      current_slide: 0
    },
    {
      country: 'China',
      countryId: 2,
      sdgIds: [],
      subjectIds: [3],
      heading: 'Arrival in China',
      movie: 'https://www.youtube.com/embed/2wzIOkTuaps',

      label: '',

      current_slide: 0
    },
    {
      country: 'China',
      countryId: 2,
      sdgIds: [],
      subjectIds: [4, 15],
      heading: 'Playing games',
      movie: 'https://www.youtube.com/embed/GCoafG6Zmw4',

      label: '',

      current_slide: 0
    },
    {
      country: 'China',
      countryId: 2,
      sdgIds: [],
      subjectIds: [5],
      heading: 'Global Exploration China',
      movie: 'https://www.youtube.com/embed/pYVaKlSxDjE',

      label: '',

      current_slide: 0
    },
    {
      country: 'India',
      countryId: 4,
      sdgIds: [],
      subjectIds: [6],
      heading: 'Aftermovie India 2019 - Graaf Huyn',
      movie: 'https://www.youtube.com/embed/MzS2XZti8Ds',

      label: '',

      current_slide: 0
    },
    {
      country: 'India',
      countryId: 4,
      sdgIds: [4],
      subjectIds: [2, 13],
      heading: 'Haridwar Middle School',
      movie: 'https://www.youtube.com/embed/3p5F4J4knvU',

      label: '',

      current_slide: 0
    },
    {
      country: 'India',
      countryId: 4,
      sdgIds: [4],
      subjectIds: [2, 13],
      heading: 'Village of Hope',
      movie: 'https://www.youtube.com/embed/TM-Iknu4vr4',

      label: '',

      current_slide: 0
    },
    {
      country: 'India',
      countryId: 4,
      sdgIds: [3],
      subjectIds: [7],
      heading: 'Ravi Tickoo - Chairman India',
      movie: 'https://www.youtube.com/embed/X7KeT-VYSu0',

      label: '',

      current_slide: 0
    },
    {
      country: 'India',
      countryId: 4,
      sdgIds: [],
      subjectIds: [5],
      heading: 'Global Exploration India',
      movie: 'https://www.youtube.com/embed/TvXSH2XVr0U',

      label: '',

      current_slide: 0
    },
    {
      country: 'Indonesië',
      countryId: 5,
      sdgIds: [],
      subjectIds: [6],
      heading: 'Aftermovie Indonesië 2019 - LCL',
      movie: 'https://www.youtube.com/embed/BrKFov8Av5I',

      label: '',

      current_slide: 0
    },
    {
      country: 'Indonesië',
      countryId: 5,
      sdgIds: [3, 4, 13],
      subjectIds: [2, 13],
      heading: 'DeTara foundation',
      movie: 'https://www.youtube.com/embed/eANGkx1pjHM',

      label: '',

      current_slide: 0
    },
    {
      country: 'Indonesië',
      countryId: 5,
      sdgIds: [],
      subjectIds: [5],
      heading: 'Global Exploration Indonesië',
      movie: 'https://www.youtube.com/embed/WvQ2pe__J74',

      label: '',

      current_slide: 0
    },
    {
      country: 'Mongolië',
      countryId: 6,
      sdgIds: [4],
      subjectIds: [5],
      heading: 'Xplore Mongolië in 2 minuten',
      movie: 'https://www.youtube.com/embed/4szJucRtVlc',

      label: '',

      current_slide: 0
    },
    {
      country: 'Mongolië',
      countryId: 6,
      sdgIds: [13],
      subjectIds: [8, 11],
      heading: 'No poverty',
      movie: 'https://www.youtube.com/embed/Qx317-sKJJI',

      label: '',

      current_slide: 0
    },
    {
      country: 'Mongolië',
      countryId: 6,
      sdgIds: [],
      subjectIds: [8],
      heading: 'No poverty',
      movie: 'https://www.youtube.com/embed/0PKz74tA7Xw',

      label: '',

      current_slide: 0
    },
    {
      country: 'Mongolië',
      countryId: 6,
      sdgIds: [4, 17],
      subjectIds: [1],
      heading: 'Introducing Global friends all over the world - Mongolië',
      movie: 'https://www.youtube.com/embed/8GMixmEbKn8',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nederland',
      countryId: 7,
      sdgIds: [],
      subjectIds: [1],
      heading: 'Informatie filmpje over sponsorgeld',
      movie: 'https://www.youtube.com/embed/hlYHoVp5QL8',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nederland',
      countryId: 7,
      sdgIds: [],
      subjectIds: [1],
      heading: 'Buddy Cadeautje',
      movie: 'https://www.youtube.com/embed/UvcGmASNYbA',

      label: '',

      current_slide: 0
    },
    // {country:'Nederland',
    // countryId:7,
    // sdgIds:[],
    // subjectIds:[5],
    // heading:'Example video.mp4',
    // movie:'https://www.youtube.com/embed/pzwSmn9S2AE',

    // label:'',

    // current_slide:0
    // },
    {
      country: 'Nederland',
      countryId: 7,
      sdgIds: [],
      subjectIds: [4],
      heading: 'Global Dance Video.mp4',
      movie: 'https://www.youtube.com/embed/mYAY_ZYFRZA',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nederland',
      countryId: 7,
      sdgIds: [],
      subjectIds: [9],
      heading: 'Xplore Europe',
      movie: 'https://www.youtube.com/embed/A40c9SVD2gw',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nederland',
      countryId: 7,
      sdgIds: [],
      subjectIds: [9],
      heading: 'Xplore Europe',
      movie: 'https://www.youtube.com/embed/y6VTT5Ekr2Q',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nederland',
      countryId: 7,
      sdgIds: [],
      subjectIds: [9],
      heading: 'Xplore Europe',
      movie: 'https://www.youtube.com/embed/rTXEG5PGLrU',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nepal',
      countryId: 8,
      sdgIds: [],
      subjectIds: [10],
      heading: 'Gastgezin in Nepal',
      movie: 'https://www.youtube.com/embed/qwy8XZDEOYA',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nepal',
      countryId: 8,
      sdgIds: [],
      subjectIds: [5, 13],
      heading: 'Introducing Global friends all over the world - Nepal',
      movie: 'https://www.youtube.com/embed/1SnacX-kc14',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nepal',
      countryId: 8,
      sdgIds: [],
      subjectIds: [5, 13],
      heading: 'Introducing Global friends all over the world - Nepal',
      movie: 'https://www.youtube.com/embed/VAlEd4zzl7I',


      label: '',

      current_slide: 0
    },
    {
      country: 'Nepal',
      countryId: 8,
      sdgIds: [],
      subjectIds: [2, 13],
      heading: 'My Global Impact - Nepal',
      movie: 'https://www.youtube.com/embed/L7_kv9cvMmo',


      label: '',

      current_slide: 0
    },
    {
      country: 'Nepal',
      countryId: 8,
      sdgIds: [],
      subjectIds: [6, 16],
      heading: 'Nepal - aftermovie',
      movie: 'https://www.youtube.com/embed/nB58oDmelpo',


      label: '',

      current_slide: 0
    },
    {
      country: 'Nepal',
      countryId: 8,
      sdgIds: [],
      subjectIds: [3, 16],
      heading: 'Nepal -  dances',
      movie: 'https://www.youtube.com/embed/PsuJRrk-_PY',
      country_flag: 'assets/images/nepal-flag.svg',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nepal',
      countryId: 8,
      sdgIds: [],
      subjectIds: [3],
      heading: 'Nepal - singing ',
      movie: 'https://www.youtube.com/embed/I6EztUZp2vE',
      country_flag: 'assets/images/nepal-flag.svg',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nepal',
      countryId: 8,
      sdgIds: [],
      subjectIds: [5],
      heading: 'Xplore Nepal 2018',
      movie: 'https://www.youtube.com/embed/OQETcbCgCdo',
      country_flag: 'assets/images/nepal-flag.svg',

      label: '',

      current_slide: 0
    },
    {
      country: 'Peru',
      countryId: 9,
      sdgIds: [],
      subjectIds: [6],
      heading: 'Aftermovie Peru 2019 - Stella Maris',
      movie: 'https://www.youtube.com/embed/JwI_Wz94XBc',

      label: '',

      current_slide: 0
    },
    {
      country: 'Peru',
      countryId: 9,
      sdgIds: [],
      subjectIds: [5],
      heading: 'Introducing Global friends all over the world - Peru',
      movie: 'https://www.youtube.com/embed/EUiG3QWdRxc',

      label: '',

      current_slide: 0
    },
    {
      country: 'Peru',
      countryId: 9,
      sdgIds: [],
      subjectIds: [10],
      heading: 'Peru Gastgezin',
      movie: 'https://www.youtube.com/embed/SWiaYzgT6Iw',

      label: '',

      current_slide: 0
    },
    {
      country: 'Peru',
      countryId: 9,
      sdgIds: [],
      subjectIds: [5],
      heading: 'Global Exploration Peru',
      movie: 'https://www.youtube.com/embed/fMX_SWc8xdU',

      label: '',

      current_slide: 0
    },
    {
      country: 'Tanzania',
      countryId: 10,
      sdgIds: [4],
      subjectIds: [5],
      heading: 'Introducing Global friends all over the world - Tanzania',
      movie: 'https://www.youtube.com/embed/jAf20pT6-xg',

      label: '',

      current_slide: 0
    },
    {
      country: 'Tanzania',
      countryId: 10,
      sdgIds: [4],
      subjectIds: [4, 17],
      heading: 'Monduli secondary school',
      movie: 'https://www.youtube.com/embed/DOrGkhkYpA8',

      label: '',

      current_slide: 0
    },
    {
      country: 'Tanzania',
      countryId: 10,
      sdgIds: [4],
      subjectIds: [5, 14],
      heading: 'Warm welcome in Tanzania',
      movie: 'https://www.youtube.com/embed/E3xNeVRyLQM',

      label: '',

      current_slide: 0
    },
    {
      country: 'Tanzania',
      countryId: 10,
      sdgIds: [],
      subjectIds: [11],
      heading: 'Climate Action',
      movie: 'https://www.youtube.com/embed/nUHgq9GmB2c',

      label: '',

      current_slide: 0
    },
    {
      country: 'Tanzania',
      countryId: 10,
      sdgIds: [4],
      subjectIds: [3, 14],
      heading: 'Tanzania - Singing "Jambo"',
      movie: 'https://www.youtube.com/embed/VqGdR9tPgQk',

      label: '',

      current_slide: 0
    },
    {
      country: 'Thailand',
      countryId: 11,
      sdgIds: [],
      subjectIds: [7],
      heading: 'Update Covid Thailand from a buddy',
      movie: 'https://www.youtube.com/embed/s_HNgPN4NGs',

      label: '',

      current_slide: 0
    },
    {
      country: 'Thailand',
      countryId: 11,
      sdgIds: [],
      subjectIds: [7],
      heading: 'Update Covid Thailand from a buddy',
      movie: 'https://www.youtube.com/embed/houqyv-n4IM',

      label: '',

      current_slide: 0
    },
    {
      country: 'Thailand',
      countryId: 11,
      sdgIds: [],
      subjectIds: [7],
      heading: 'Update Covid Thailand from a buddy',
      movie: 'https://www.youtube.com/embed/lfIB0DZT3vo',

      label: '',

      current_slide: 0
    },
    {
      country: 'Thailand',
      countryId: 11,
      sdgIds: [4],
      subjectIds: [5, 17],
      heading: 'Prachaywatakern International School',
      movie: 'https://www.youtube.com/embed/fUkckBjFA7M',

      label: '',

      current_slide: 0
    },
    {
      country: 'Thailand',
      countryId: 11,
      sdgIds: [1, 2, 3],
      subjectIds: [2, 13],
      heading: 'House of Grace',
      movie: 'https://www.youtube.com/embed/DyFNAg9rqsw',

      label: '',

      current_slide: 0
    },
    {
      country: 'Cambodja',
      countryId: 3,
      sdgIds: [4],
      subjectIds: [2, 13],
      heading: 'CCF Mukda Village',
      movie: 'https://www.youtube.com/embed/Fp2STiVffFE',
      country_flag: 'assets/images/thailand-flag.svg',
      lat: 11.33,
      lng: 104.55,
      label: '',

      current_slide: 0
    },
    {
      country: 'Cambodja',
      countryId: 3,
      sdgIds: [],
      subjectIds: [5],
      heading: 'Global Exploration Thailand Cambodja',
      movie: 'https://www.youtube.com/embed/gztyGeQgWJI',
      country_flag: 'assets/images/thailand-flag.svg',
      lat: 11.33,
      lng: 104.55,
      label: '',

      current_slide: 0
    },
    {
      country: 'Togo',
      countryId: 12,
      sdgIds: [],
      subjectIds: [6],
      heading: 'Aftermovie Togo 2018',
      movie: 'https://www.youtube.com/embed/Og-3Gdx5QzI',

      label: '',

      current_slide: 0
    },
    {
      country: 'Togo',
      countryId: 12,
      sdgIds: [],
      subjectIds: [5],
      heading: 'Introducing Global friends all over the world - Togo',
      movie: 'https://www.youtube.com/embed/0fXULSjuRoM',

      label: '',

      current_slide: 0
    },
    {
      country: 'Togo',
      countryId: 12,
      sdgIds: [],
      subjectIds: [10],
      heading: 'Togo Gezin',
      movie: 'https://www.youtube.com/embed/RjaP506UQRY',

      label: '',

      current_slide: 0
    },
    {
      country: 'Togo',
      countryId: 12,
      sdgIds: [],
      subjectIds: [10],
      heading: 'Togo Gezin 2',
      movie: 'https://www.youtube.com/embed/y4geIVP166Q',

      label: '',

      current_slide: 0
    },
    {
      country: 'Togo',
      countryId: 12,
      sdgIds: [],
      subjectIds: [5],
      heading: 'Global Exploration Togo',
      movie: 'https://www.youtube.com/embed/Ldhqnzu3Vuo',

      label: '',

      current_slide: 0
    },
    {
      country: 'Uganda',
      countryId: 13,
      sdgIds: [],
      subjectIds: [5],
      heading: 'Introducing Global friends all over the world - Uganda',
      movie: 'https://www.youtube.com/embed/X7S9mMiwPh8',

      label: '',

      current_slide: 0
    },
    {
      country: 'Uganda',
      countryId: 13,
      sdgIds: [1],
      subjectIds: [2, 13],
      heading: 'My Global Impact - Uganda',
      movie: 'https://www.youtube.com/embed/38Bx3oqoV3Y',

      label: '',

      current_slide: 0
    },
    {
      country: 'Uganda',
      countryId: 13,
      sdgIds: [4],
      subjectIds: [4, 17],
      heading: 'Bukedi College',
      movie: 'https://www.youtube.com/embed/_7-h_rNG6vs',

      label: '',

      current_slide: 0
    },
    {
      country: 'Zuid-Afrika',
      countryId: 14,
      sdgIds: [],
      subjectIds: [4],
      heading: 'One Billion Rising Porta Mosana ZA 2019',
      movie: 'https://www.youtube.com/embed/N23SgSlsAFY',

      label: '',

      current_slide: 0
    },
    {
      country: 'Zuid-Afrika',
      countryId: 14,
      sdgIds: [],
      subjectIds: [6],
      heading: 'Aftermovie Zuid-Afrika 2019 - Porta Mosana',
      movie: 'https://www.youtube.com/embed/5BMkHz9GV0o',

      label: '',

      current_slide: 0
    },
    {
      country: 'Zuid-Afrika',
      countryId: 14,
      sdgIds: [],
      subjectIds: [5],
      heading: 'Introducing Global friends all over the world - Zuid-Afrika',
      movie: 'https://www.youtube.com/embed/sFxXTXE2zMk',

      label: '',

      current_slide: 0
    },
    {
      country: 'Zuid-Afrika',
      countryId: 14,
      sdgIds: [],
      subjectIds: [12],
      heading: 'Covid update Zuid-Afrika',
      movie: 'https://www.youtube.com/embed/01BIa2fZfj0',

      label: '',

      current_slide: 0
    },
    {
      country: 'Zuid-Afrika',
      countryId: 14,
      sdgIds: [],
      subjectIds: [2, 13],
      heading: 'Scholen voor scholen Zuid-Afrika',
      movie: 'https://www.youtube.com/embed/e3dRdfwGyhk',

      label: '',

      current_slide: 0
    },
    {
      country: 'Zuid-Afrika',
      countryId: 14,
      sdgIds: [],
      subjectIds: [10],
      heading: 'Zuid-Afrika Gastgezin',
      movie: 'https://www.youtube.com/embed/J_5jvZydMc4',

      label: '',

      current_slide: 0
    },
    {
      country: 'Zuid-Afrika',
      countryId: 14,
      sdgIds: [],
      subjectIds: [4],
      heading: 'Onderwijs in Zuid-Afrika',
      movie: 'https://www.youtube.com/embed/pIiRsFYsRcg',

      label: '',

      current_slide: 0
    },
    {
      country: 'Zuid-Afrika',
      countryId: 14,
      sdgIds: [1, 5, 17],
      subjectIds: [8],
      heading: "SDG's in Zuid-Afrika",
      movie: 'https://www.youtube.com/embed/mXhPtMoaGa0',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nederland',
      countryId: 7,
      sdgIds: [4],
      subjectIds: [18],
      heading: 'A tour through Bernardinus College',
      movie: 'https://www.youtube.com/embed/JDAGVF5xBsI',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nederland',
      countryId: 7,
      sdgIds: [6],
      subjectIds: [19],
      heading: 'The toilets in a dutch middle school ',
      movie: 'https://www.youtube.com/embed/xjbwjxRyXV8',

      label: '',

      current_slide: 0
    },
    {
      country: 'Uganda',
      countryId: 13,
      sdgIds: [2],
      subjectIds: [8],
      heading: 'Where do you get your food in Uganda?',
      movie: 'https://www.youtube.com/embed/AnmH_WinIsc',

      label: '',

      current_slide: 0
    },
    {
      country: 'Uganda',
      countryId: 13,
      sdgIds: [1],
      subjectIds: [8],
      heading: 'When do you consider wealthy or rich in Uganda?',
      movie: 'https://www.youtube.com/embed/jKHqiN6M0Yk',

      label: '',

      current_slide: 0
    },
    {
      country: 'Uganda',
      countryId: 13,
      sdgIds: [9],
      subjectIds: [8],
      heading: 'Do you have acces to the internet?',
      movie: 'https://www.youtube.com/embed/oKMTi0pgmZw',

      label: '',

      current_slide: 0
    },
    {
      country: 'Uganda',
      countryId: 13,
      sdgIds: [8],
      subjectIds: [8],
      heading: 'Do you have a sidejob?',
      movie: 'https://www.youtube.com/embed/XtKud7x57JU',

      label: '',

      current_slide: 0
    },
    {
      country: 'Uganda',
      countryId: 13,
      sdgIds: [16],
      subjectIds: [8],
      heading: 'What does freedom mean for you?',
      movie: 'https://www.youtube.com/embed/_4PDUALzMlQ',

      label: '',

      current_slide: 0
    },
    {
      country: 'Uganda',
      countryId: 13,
      sdgIds: [4],
      subjectIds: [8],
      heading: 'What does a typical schoolday look like? ',
      movie: 'https://www.youtube.com/embed/XY6K2qHIXjE',

      label: '',

      current_slide: 0
    },
    {
      country: 'India',
      countryId: 4,
      sdgIds: [4],
      subjectIds: [8],
      heading: 'Education in India',
      movie: 'https://www.youtube.com/embed/L4kl03Dtfbk',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nederland',
      countryId: 7,
      sdgIds: [2],
      subjectIds: [8],
      heading: 'Where do you get your food from in the Netherlands?',
      movie: 'https://www.youtube.com/embed/5m_MrrJTeW8',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nederland',
      countryId: 7,
      sdgIds: [16],
      subjectIds: [8],
      heading: 'Do you feel safe in the Netherlands?',
      movie: 'https://www.youtube.com/embed/001eXMlMgvI',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nederland',
      countryId: 7,
      sdgIds: [8],
      subjectIds: [8],
      heading: 'Do you have a sidejob in the netherlands?',
      movie: 'https://www.youtube.com/embed/Ny6cUkl_WTQ',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nederland',
      countryId: 7,
      sdgIds: [6],
      subjectIds: [8],
      heading: 'What do the bathrooms look like in the Netherlands?',
      movie: 'https://www.youtube.com/embed/NMpb0o1q4cc',

      label: '',

      current_slide: 0
    },
    {
      country: 'Nederland',
      countryId: 7,
      sdgIds: [3],
      subjectIds: [8],
      heading: 'What happens if you break a leg in the Netherlands?',
      movie: 'https://www.youtube.com/embed/3YOJvXcINGk',

      label: '',

      current_slide: 0
    }

  ]

  countryList = [
    { id: 1, name: 'Bhutan', country_flag: 'assets/images/bhutan-flag.svg', lat: 27.421263, lng: 90.468131, icon: 'assets/images/bhutan-marker.svg' },
    { id: 2, name: 'China', country_flag: 'assets/images/china-flag.svg', lat: 35.208392, lng: 103.627022, icon: 'assets/images/china-marker.svg' },
    { id: 3, name: 'Cambodja', country_flag: 'assets/images/thailand-flag.svg', lat: 12.747914, lng: 104.955314, icon: 'assets/images/thailand-marker.svg' },
    { id: 4, name: 'India', country_flag: 'assets/images/india-flag.svg', lat: 22.952522, lng: 79.828673, icon: 'assets/images/india-marker.svg' },
    { id: 5, name: 'Indonesië', country_flag: 'assets/images/indonesia-flag.svg', lat: -4.074839, lng: 122.130349, icon: 'assets/images/indonesia-marker.svg' },
    { id: 6, name: 'Mongolië', country_flag: 'assets/images/mongolie-flag.svg', lat: 46.904436, lng: 103.117823, icon: 'assets/images/mongolie-marker.svg' },
    { id: 7, name: 'Nederland', country_flag: 'assets/images/nederland-flag.svg', lat: 52.211934, lng: 5.563602, icon: 'assets/images/nederland-marker.svg' },
    { id: 8, name: 'Nepal', country_flag: 'assets/images/nepal-flag.svg', lat: 28.253270, lng: 83.896645, icon: 'assets/images/nepal-marker.svg' },
    { id: 9, name: 'Peru', country_flag: 'assets/images/peru-flag.svg', lat: -10.256692, lng: -75.099194, icon: 'assets/images/peru-marker.svg' },
    { id: 10, name: 'Tanzania', country_flag: 'assets/images/tanzania-flag.svg', lat: -6.331491, lng: 34.886291, icon: 'assets/images/tanzania-marker.svg' },
    { id: 11, name: 'Thailand', country_flag: 'assets/images/thailand-flag.svg', lat: 15.449498, lng: 101.123293, icon: 'assets/images/thailand-marker.svg' },
    { id: 12, name: 'Togo', country_flag: 'assets/images/togo-flag.svg', lat: 8.690799, lng: 0.938912, icon: 'assets/images/togo-marker.svg' },
    { id: 13, name: 'Uganda', country_flag: 'assets/images/uganda-flag.svg', lat: 1.531855, lng: 32.277842, icon: 'assets/images/uganda-marker.svg' },
    { id: 14, name: 'Zuid-Afrika', country_flag: 'assets/images/zuid-Afrika-flag.svg', lat: -30.853973, lng: 23.742758, icon: 'assets/images/zuid-Afrika-marker.svg' }
  ]

  filters = {
    country: [
      { id: 1, name: 'Bhutan' },
      { id: 2, name: 'China' },
      { id: 3, name: 'Cambodja' },
      { id: 4, name: 'India' },
      { id: 5, name: 'Indonesië' },
      { id: 6, name: 'Mongolië' },
      { id: 7, name: 'Nederland' },
      { id: 8, name: 'Nepal' },
      { id: 9, name: 'Peru' },
      { id: 10, name: 'Tanzania' },
      { id: 11, name: 'Thailand' },
      { id: 12, name: 'Togo' },
      { id: 13, name: 'Uganda' },
      { id: 14, name: 'Zuid-Afrika' }
    ],
    // sdg:['Quality education','Good helth and well-being','No poverty'],
    sdg: [{
      id: 1,
      name: '1-No poverty'
    },
    {
      id: 2,
      name: '2-Zero-hunger'
    },
    {
      id: 3,
      name: '3-Good health and well-being'
    },
    {
      id: 4,
      name: '4-Quality education'
    },
    {
      id: 5,
      name: '5-Gender equality'
    },
    {
      id: 6,
      name: '6-Clean water and sanitation'
    },
    {
      id: 7,
      name: '7-Affordable and clean energy'
    },
    {
      id: 8,
      name: '8-Decent work and economic growth'
    },
    {
      id: 9,
      name: '9-Industry innovation and infrastructure'
    },
    {
      id: 10,
      name: '10-Reduced inequalities'
    },
    {
      id: 11,
      name: '11-Sustainable cities and communities'
    },
    {
      id: 12,
      name: '12-Responsible consumption and production'
    },
    {
      id: 13,
      name: '13-Climate action'
    },
    {
      id: 14,
      name: '14-Life below water'
    },
    {
      id: 15,
      name: '15-Life on land'
    },
    {
      id: 16,
      name: '16-Peace,justice and strong institutions'
    },
    {
      id: 17,
      name: '17-Partnerships for the goals'
    },


    ],
    // subject:[
    //           'Aftermovie','Covid','Corona','Introductie','Buddy','Project','Activiteiten','Global +','(Promotie filmpje) Sfeerbeelden van China, de projecten en overzicht van de dagen','partnership for the goals + gender equality + no poverty','De Payi familie, gastgezin in Zuid-Afrika',
    //           'partnership for the goals + gender equality + no poverty','Opening afgelopen jaar met alle landen','Scholen voor Scholen','Ayanou-Ahobli familie, gastgezin in Togo','Bukedi college','Scholen voor Scholen, Partners','Voetballen met primary school in China',
    //           'Opening 2020 officiele versie'
    //         ]
    subject: [
      {
        id: 1,
        name: 'Training'
      },
      {
        id: 2,
        name: 'Scholen voor Scholen'
      },
      {
        id: 3,
        name: 'Cultuur'
      },
      {
        id: 4,
        name: 'Educatie en sport'
      },
      {
        id: 5,
        name: 'Wereldburgerschap'
      },
      {
        id: 6,
        name: 'Aftermovie'
      },
      {
        id: 7,
        name: 'Covid'
      },
      {
        id: 8,
        name: 'SDG'
      },
      {
        id: 9,
        name: 'Xplore Europe '
      },
      {
        id: 10,
        name: 'Gastgezin'
      },
      {
        id: 11,
        name: 'Natuur'
      },
      {
        id: 12,
        name: 'Corona'
      },
      {
        id: 13,
        name: 'Partners'
      },
      {
        id: 14,
        name: 'Gidsen'
      },
      {
        id: 15,
        name: 'Basisschool'
      },
      {
        id: 16,
        name: 'Cultuur & educatie'
      },
      {
        id: 17,
        name: 'middelbare school'
      },
      {
        id: 18,
        name: 'Education'
      },
      {
        id: 19,
        name: 'Health'
      }



    ]
  }

  private renderer: Renderer2;

  // private document: Document,
  constructor(private http: HttpClient, 
    rendererFactory: RendererFactory2 , public snackBar: MatSnackBar) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  // student section

  validateReferal(code) {
    return this.http.get(this.$baseUrl + '/accounts/validate-code/?code=' + code);
  }

  signUP(data) {
    return this.http.post(this.$baseUrl + '/accounts/participant/signup/', data);
  }

  login(data) {
    return this.http.post(this.$baseUrl + '/accounts/login/', data);
  }

  getParticipantData() {
    
    const data = localStorage.getItem('userData');
    const userData = data ? JSON.parse(data) : '';
    return this.http.get(this.$baseUrl + '/accounts/participant/' + userData.id + '/', this.Options());
  }

  getSDGfilter() {
    return this.http.get(this.$baseUrl + '/explore/dropdown/sdg/?limit=1000&offset=0', this.Options());
  }

  getSDGPublicfilter() {
    return this.http.get(this.$baseUrl + '/explore/public/dropdown/sdg/?limit=1000&offset=0', this.Options());
  }

  getCategoryPublicFilter() {
    return this.http.get(this.$baseUrl + '/explore/public/dropdown/category/');
  }

  getCategoryFilter(){
    return this.http.get(this.$baseUrl + '/explore/dropdown/category/?limit=1000&offset=0', this.Options());
  }

  getCountryFilter(params?) {
    return this.http.get(this.$baseUrl + `/explore/dropdown/country/?limit=1000&offset=0&is_question=${params?.is_question}&difficulty=${params.difficulty}`, this.Options());
  }

  getCountryPublicFilter() {
    return this.http.get(this.$baseUrl + '/explore/public/dropdown/country/?limit=1000&offset=0');
  }

  getSubjectList() {
    return this.http.get(this.$baseUrl + '/explore/dropdown/topic/?limit=1000&offset=0', this.Options());
  }

  getSubjectPublicList() {
    return this.http.get(this.$baseUrl + '/explore/public/dropdown/topic/?limit=1000&offset=0', this.Options());
  }


  getAttendQuestion(param) {

    return this.http.get(this.$baseUrl + '/quiz/question/?sdg=' + param.sdg + '&country=' + param.country + '&topic=' + param.subject + '&attempted=' + param.attempted, this.Options());
  }

  getAnswerQuestion(param) {

    return this.http.get(this.$baseUrl + '/quiz/question/?sdg=' + param.sdg + '&country=' + param.country + '&topic=' + param.subject + '&is_right=' + param.is_right, this.Options());
  }

  getQuestionList(param) {
    return this.http.get(this.$baseUrl + '/quiz/question/?limit=1000&offset=0&sdg=' + param.sdg + '&country=' + param.country + '&topic=' + param.subject, this.Options());
  }

  getWrongQuestionList(param) {
    return this.http.get(this.$baseUrl + '/quiz/question/wrong/?limit=10&offset=' + param.offset + '&sdg=' + param.sdg + '&country=' + param.country + '&topic=' + param.subject + '&difficulty=' + param.difficulty, this.Options());
  }

  getRightQuestionList(param) {
    return this.http.get(this.$baseUrl + '/quiz/question/right/?limit=1000&offset=' + param.offset + '&sdg=' + param.sdg + '&country=' + param.country + '&topic=' + param.subject + '&difficulty=' + param.difficulty, this.Options());
  }

  getUnansweredQuestionList(param) {
    return this.http.get<ResponseType<ResultData<UnQnList>>>(this.$baseUrl + '/quiz/question/unanswered/?limit=1000&offset=0&sdg=' + param.sdg + '&country=' + param.country + '&topic=' + param.subject + '&difficulty=' + param.difficulty + '&category=' + param.category, this.Options());
  }

  getQuestionPublicList(param) {
    return this.http.get(this.$baseUrl + '/quiz/public/question/?limit=10&offset=' + param.offset + '&sdg=' + param.sdg + '&country=' + param.country + '&topic=' + param.subject + '&difficulty=' + param.difficulty, this.Options());
  }

  getQuestionStatus(param) {
    return this.http.get<ResponseType<QuestionStatus>>(this.$baseUrl + '/quiz/status/?sdg=' + param.sdg + '&country=' + param.country + '&difficulty=' + param.difficulty + '&category='+ param.category, this.Options());
  }

  getQuestionPublicStatus(param) {
    return this.http.get(this.$baseUrl + '/quiz/public/status/?sdg=' + param.sdg + '&country=' + param.country + '&topic=' + param.subject + '&difficulty=' + param.difficulty, this.Options());
  }

  getCountriesMap() {
    return this.http.get(this.$baseUrl + '/explore/list/country/?limit=1000&offset=0', this.Options());
  }

  getCountriesPublicMap() {
    return this.http.get(this.$baseUrl + '/explore/public/list/country/?limit=1000&offset=0', this.Options());
  }

  getSDGlist() {
    return this.http.get(this.$baseUrl + '/explore/list/sdg/?limit=1000&offset=0', this.Options());
  }

  getCategorylist() {
    return this.http.get(this.$baseUrl + '/explore/list/category/?limit=1000&offset=0', this.Options());
  }

  getModalQuestion(params) {
    return this.http.get<ResponseType<QuestionDetails>>(this.$baseUrl + `/quiz/question/${params.id}/?category=${params.category}&country=${params.country}&difficulty=${params.difficulty}`, this.Options());
  }

  markAnswer(id, data) {
    return this.http.patch(this.$baseUrl + '/quiz/mark-answer/' + id + '/', data, this.Options());
  }

  getVideoList(param) {
    return this.http.get(this.$baseUrl + '/explore/public/video/?limit=1000&country=' + param.country + '&category=' + param.category + '&search=' + param.search);
  }

  getCountryVideoList(param?) {
    // return this.http.get(this.$baseUrl + '/explore/list/country-video/?limit=1000&offset=0', this.Options());
    return this.http.get(this.$baseUrl + '/explore/public/list/country-video/?limit=1000&offset=0&sdg=' + param.sdg + '&country=' + param.country + '&category=' + param.subject + '&search=' + param.search, this.Options());
  }

  // teachers section ---------------------------------------------------------------------

  validateTeacherReferal(code) {
    return this.http.get(this.$baseUrl + '/accounts/teacher/validate-code/?code=' + code);
  }

  signUpTeacher(data) {
    return this.http.post(this.$baseUrl + '/accounts/teacher/signup/', data);
  }

  postTeamGroup(body){
    return this.http.post(this.$baseUrl + '/teamquiz/teacher/team-groups/', body);
  }
  
  patchTeamGroup(id:string,body){
    return this.http.patch(this.$baseUrl + `/teamquiz/teacher/team-groups/${id}/`, body);
  }
  
  getTeamGroup(id){
    return this.http.get<ResponseData<TeamGroup>>(this.$baseUrl + `/teamquiz/teacher/team-groups/${id}/`);
  }

  startQuiz(id:string,body){
    return this.http.patch<ResponseData<TeamGroup>>(this.$baseUrl + `/teamquiz/teacher/team-groups/${id}/`,body);
  }

  endQuiz(id:string,body){
    return this.http.patch(this.$baseUrl + `/teamquiz/teacher/team-groups/${id}/`,body);
  }

  getLeaderboard(id:string){
    return this.http.get<ResponseData<Leaderboard>>(this.$baseUrl + `/teamquiz/teacher/leaderboard/${id}/`);
  }

  getFinalResult(id:string){
    return this.http.get<ResponseData<{winning_team:string[]}>>(this.$baseUrl + `/teamquiz/teacher/quizresult/${id}/`);
  }
  
  getTeacherGroupStatus(){
    return this.http.get(this.$baseUrl + `/teamquiz/teacher/status/`);
  }

  getGameResult(){
    return this.http.get(this.$baseUrl + `/teamquiz/teacher/latest-result/`);
  }
  
  // student team play
  
  validateTeamCode(body){
    return this.http.post(this.$baseUrl + `/teamquiz/team/validate-code/`,body);
  }

  getWaitingTeamStatus(id:string){
    return this.http.get<ResponseData<TeamDetails>>(this.$baseUrl + `/teamquiz/team/${id}/`);
  }

  getServerTime(id:string){
    return this.http.get(this.$baseUrl + `/teamquiz/team/get-timer/${id}/`);
  }

  getQuizQestionList(id:string){
    return this.http.get(this.$baseUrl + `/teamquiz/team/unanswered/?team=${id}`);
  }

  getQuizQuestion(questionId:string,teamId:string){
    return this.http.get(this.$baseUrl + `/teamquiz/team/question/${questionId}/?team=${teamId}`);
  }

  patchQuizAnswer(questionId:string,teamId:string,body){
    return this.http.patch(this.$baseUrl + `/teamquiz/team/mark-answer/${questionId}/?team=${teamId}`,body);
  }

  studentQuizCompleted(teamId:string,body){
    return this.http.patch(this.$baseUrl + `/teamquiz/team/${teamId}/`,body);
  }

  // mouse loader -------------------------------------------------

  showMouseLoader() {
    // this.renderer.addClass(this.document.body, 'mouseLoader');
  }

  hideMouseLoader() {
    // this.renderer.removeClass(this.document.body, 'mouseLoader');
  }

  // httpOptions
  Options() {
    const userData = localStorage.getItem('userData');
    const data = userData ? JSON.parse(userData) : '';
    let language = '';
    // if (localStorage.getItem('laguage') == 'en') {
    //   language = 'en-us';
    // }

    if (localStorage.getItem('userLang') == 'en') {
      language = 'en-us';
    } else {
      language = 'nl';
    }

    if (data != null || data != undefined) {
      var httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'bearer': data.token,
          'User-ID': data.id,
          'Language': language
        })
      };
    } else {
      var httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Language': language
        })
      };
    }
    return httpOptions;
  }

  // snackbar success/error messages
  customSnackBar(message: string, type: string, status: string , duration?:number) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: {
        message: message,
        type: type,
        status: status
      },
      duration:duration ? duration : 5000,

    });
  }

}
